package dev.moetz.chatoverlay.model

import dev.moetz.chatoverlay.manager.EmoteOrText

data class ChatMessage(
    val id: String,
    val roomId: String,
    val roomProfileImageUrl: String,
    val badges: List<Badge>,
    val color: String?,
    val displayName: String,
    val isSlashMe: Boolean,
    val messageFragments: List<EmoteOrText>,
) {
    data class Badge(
        val url: String,
        val set: String,
        val value: String,
    ) {
        val isPredictionBadge: Boolean get() = set.equals("predictions", ignoreCase = true)
        val isModeratorBadge: Boolean get() = set.equals("moderator", ignoreCase = true)
        val isSubscriberBadge: Boolean get() = set.equals("subscriber", ignoreCase = true)
    }
}
